module.exports = __webpack_public_path__ + "img/img-top.f7ea000d.png";